<template>
  <div>
    <loader />
  </div>
</template>

<script>
import auth from '@/services/auth';
import HTTPService from '@/services/Http';

import { TELEGRAM_BOT_LINK } from 'root/.env';

import Loader from '@/components/otherElements/Loader';

export default {
  name: 'TelegramBotBinding',
  // https://capusta.space/bot/telegram/subscribe?cid=146264254&tid=146264254&sign=7D1F5493A68765D5A03F9FFF1E12DB50
  components: {
    Loader,
  },
  created() {
    if (auth.user.authenticated) {
      HTTPService.telegramBotBind(this.$route.query)
        .then(() => {
          this.$alert({
            type: 'success',
            text: this.$t('telegram.bot.binded'),
          });

          window.open(TELEGRAM_BOT_LINK);
        })
        .catch(() => {
          this.$alert({
            type: 'warning',
            text: this.$t('telegram.bot.not.binded'),
          });
        })
        .finally(() => this.$router.push({ name: 'cabinet' }));
    } else {
      localStorage.setItem('botBinding', JSON.stringify(this.$route.query));

      this.$alert({
        type: 'warning',
        text: this.$t('log.in.to.bind.bot'),
      });

      this.$router.push({ name: 'login' });
    }
  },
};
</script>
